export default __webpack_public_path__ + "static/media/cannon-3.f49f3557.svg";